module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Ancient-Assassins-2.e06cb58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Ancient-Assassins-2.jpg
// module id = cGji
// module chunks = 0